var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.025 4.175C19.2859 4.50313 18.4938 4.72344 17.6609 4.82344C18.5109 4.31406 19.1641 3.50781 19.4703 2.54844C18.6766 3.01875 17.7938 3.36094 16.8578 3.54531C16.1078 2.74531 15.0391 2.24688 13.8563 2.24688C11.5844 2.24688 9.74219 4.0875 9.74219 6.35938C9.74219 6.68125 9.77969 6.99531 9.85 7.29688C6.43125 7.125 3.40156 5.4875 1.37188 2.99844C1.01719 3.60781 0.815625 4.31406 0.815625 5.06719C0.815625 6.49375 1.54063 7.75313 2.64531 8.49219C1.97031 8.47031 1.33594 8.28438 0.78125 7.97656C0.78125 7.99375 0.78125 8.01094 0.78125 8.02813C0.78125 10.0219 2.2 11.6828 4.07969 12.0625C3.73594 12.1562 3.37188 12.2063 2.99688 12.2063C2.73125 12.2063 2.47344 12.1813 2.22188 12.1313C2.74688 13.7641 4.26563 14.9563 6.06406 14.9891C4.65781 16.0922 2.88438 16.7484 0.95625 16.7484C0.623438 16.7484 0.296875 16.7297 -0.0234375 16.6906C1.79531 17.8594 3.95781 18.5391 6.28125 18.5391C13.8469 18.5391 17.9844 12.2719 17.9844 6.8375C17.9844 6.65938 17.9797 6.47969 17.9734 6.30469C18.7766 5.725 19.4734 5 20.025 4.175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.974af9d8924d82396bea5c69de385182.svg";
export { ForwardRef as ReactComponent };